// extracted by mini-css-extract-plugin
export default {"favoriteButton":"FavoriteButton_favoriteButton__gZh+1","filled":"FavoriteButton_filled__nht4h","empty":"FavoriteButton_empty__1QSPv"};